import React from "react";

export function useIsMobileWidth({
  containerRef,
}: {
  containerRef: React.RefObject<HTMLDivElement>;
}) {
  // Inside your component
  // const containerRef = useRef<HTMLDivElement>(null);
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    // Function to check and update the isMobile state
    const checkIsMobile = () => {
      const currentWidth = containerRef.current?.clientWidth;
      if (currentWidth !== undefined) {
        setIsMobile(currentWidth < 500);
      }
    };

    // Call checkIsMobile on mount
    checkIsMobile();

    // Optional: If you expect the container's size to change, use ResizeObserver to observe size changes
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        checkIsMobile(); // Check if it's mobile whenever there's a resize event
      }
    });

    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    // Cleanup function to disconnect the ResizeObserver
    return () => {
      if (containerRef.current) {
        resizeObserver.disconnect();
      }
    };
  }, []); // Empty dependency array means this effect runs once on mount

  return isMobile;
}
